'use client';
import './SquareCardGroup.style.scss';
import cn from 'classnames';
import SquareCard, { SquareCardProps } from '../SquareCard/SquareCard';
import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';

type SquareCardGroupProps = {
  cards: SquareCardProps[];
  gapHoriz: number;
  gapVertical: number;
  carouselOnMobile?: boolean;
  slightlySmallerCopy?: boolean;
};

function SquareCardGroup(props: SquareCardGroupProps) {
  const { gapHoriz, gapVertical, carouselOnMobile, slightlySmallerCopy } =
    props;

  const cards = slightlySmallerCopy
    ? props.cards.map((card) => ({ ...card, slightlySmallerCopy: true }))
    : props.cards;

  return (
    <>
      {/* This div is what is shown on desktop, and also what is shown on mobile if `carouselOnMobile` is false */}
      <div
        className={cn('SquareCardGroup', carouselOnMobile && 'hideOnMobile')}
        style={{
          gap: gapHoriz,
          rowGap: gapVertical
        }}
      >
        {cards.map((card, index) => (
          <SquareCard
            key={index}
            {...card}
          />
        ))}
      </div>

      {/* This div is what is shown on mobile if `carouselOnMobile` is true */}
      {carouselOnMobile && (
        <SlickCarousel
          className='SquareCardGroup-carousel'
          slickSettings={{
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            variableWidth: true
          }}
        >
          {cards.map((card, index) => (
            <SquareCard
              customStyling={{
                marginRight: gapHoriz
              }}
              key={index}
              {...card}
            />
          ))}
        </SlickCarousel>
      )}
    </>
  );
}

export default SquareCardGroup;
